module.exports = __webpack_public_path__ + "static/media/defeat.c12fa724.mp3";